import React, { useEffect, useState } from "react";
import "../../asset/css/banner.css";
import { get } from "../../config/ajaxRequest";

export default function Banner() {
	const [textData, setTextData] = useState([]); // Initialize as an empty array

	useEffect(() => {
		const fetchData = async () => {
			try {
				const res = await get("home/files");
				const myRes = res.textData; // Destructure specific properties
				setTextData(myRes); // Update state with individual properties
				//console.log(myRes, "text data here...");
			} catch (err) {
				console.error("Error fetching data:", err);
			}
		};

		fetchData();
	}, []);

	return (
		<div className="mt-3 bannertop">
			{textData.map((item, index) => (
				<div key={index} className="banner-item">
					<h1 className="small-text">{item.bigtext}</h1>
					<h4 className="medium-text">{item.mediumtext}</h4>
					<small className="big-text">{item.smalltext}</small>
				</div>
			))}
		</div>
	);
}
